/* Kameo matras- en topper-keuzehulp (collecties matrassen en toppers)
   Opent vanaf elke link met [data-kkh-open]. Tikvragen met iconen (theme-assets kkh-ic-*.png),
   vaste beslisregels, en daarna licht de juiste kaart op de pagina op. Kaarten worden herkend
   aan hun titel (Essence / Flow / Flex), zodat het advies blijft kloppen als het product op
   een kaart wordt omgezet. Prijs, beeld en link in het advies komen van diezelfde kaart.

   Versie 2 (2026-10-31, akkoord Steinar): topper vraagt naar hoe je wilt liggen, de staat van
   het matras (kuil = eerlijk advies: nieuw matras) en de ondergrond; matras vraagt naar
   klachten (meerdere keuzes) en of je je hardheid al weet. Te hard of zachter willen geeft
   altijd de Flow Topper: die is het soepelst, Essence en Flex liggen stugger (Steinar).

   Meten: elk antwoord, het advies en de vervolgklik gaan (alleen met statistiek-consent) naar
   de events-tabel van de Kameo Cart-app, met bron 'keuzehulp' of 'keuzehulp-topper', plus een
   dataLayer-event 'kameo_keuzehulp' voor GA4. */
(function () {
  'use strict';
  if (window.__kkh) return;
  window.__kkh = true;

  /* iconen staan naast dit script in de theme-assets */
  var SCRIPT = document.currentScript || document.querySelector('script[src*="kameo-keuzehulp.js"]');
  var ICOON_BASIS = SCRIPT && SCRIPT.src ? SCRIPT.src.replace(/[^/]*$/, '') : '';
  function icoon(naam) {
    return '<img src="' + ICOON_BASIS + 'kkh-ic-' + naam + '.png" alt="" width="52" height="52" loading="eager" decoding="async">';
  }

  /* ── vragen: [waarde, label, icoon] ── */
  var VRAGEN_MATRAS = [
    { id: 'wie', tegels: true, titel: 'Voor wie is het matras?', opties: [
      ['alleen', 'Alleen voor mij', 'persoon'],
      ['samen', 'Voor mij en mijn partner', 'personen']] },
    { id: 'hardheid', alleenBij: function (a) { return a.wie === 'samen'; },
      titel: 'Houden jullie van dezelfde hardheid?', opties: [
      ['zelfde', 'Ja, dezelfde hardheid', 'balans'],
      ['verschil', 'Nee, de een zachter, de ander steviger', 'personen'],
      ['weet', 'Weet ik niet', 'weet-niet']] },
    { id: 'houding', tegels: true, titel: 'Hoe slaap je meestal?', opties: [
      ['zij', 'Op mijn zij', 'zijslaper'],
      ['rug', 'Op mijn rug', 'rugslaper'],
      ['buik', 'Op mijn buik', 'buikslaper'],
      ['wisselend', 'Wisselend', 'wisselend']] },
    { id: 'gewicht', titel: function (a) { return a.wie === 'samen' ? 'Hoeveel weegt de zwaarste van jullie?' : 'Hoeveel weeg je ongeveer?'; },
      opties: [
      ['tot70', 'Tot 70 kg'],
      ['70-85', '70 tot 85 kg'],
      ['85-110', '85 tot 110 kg'],
      ['110plus', 'Meer dan 110 kg']] },
    { id: 'klacht', meer: true, tegels: true, titel: 'Word je wel eens stijf of pijnlijk wakker?', sub: 'Kies alles wat past.', opties: [
      ['rug', 'Onderrug', 'onderrug'],
      ['nek', 'Nek of schouders', 'nek'],
      ['heup', 'Heupen', 'heup'],
      ['geen', 'Nee, nergens', 'geen']] },
    { id: 'warm', titel: 'Slaap je warm?', opties: [
      ['vaak', 'Ja, ik heb het snel warm', 'vlam'],
      ['soms', 'Soms', 'soms-warm'],
      ['nee', 'Nee, eerder koud', 'koud']] },
    { id: 'voorkeur', titel: 'Weet je welke hardheid je fijn vindt?', opties: [
      ['zacht', 'Ja, liever zacht', 'zacht'],
      ['stevig', 'Ja, liever stevig', 'stevig'],
      ['nee', 'Nee, ik wil kunnen wisselen', 'instellen']] },
    { id: 'prio', titel: 'Wat vind je het belangrijkst?', opties: [
      ['prijs', 'Een voordelige prijs', 'prijs'],
      ['balans', 'Een goede balans', 'balans'],
      ['instellen', 'Zo veel mogelijk zelf instellen', 'instellen']] }
  ];

  var NAMEN_MATRAS = { essence: 'Kameo® Essence Matras', flow: 'Kameo® Flow Matras', flex: 'Kameo® Flex Matras' };

  /* redenen: [icoon, tekst]; feiten van de productpagina's (pdp-d, pdp-d-flow, pdp-d-essence-foam) */
  var RM = {
    flex130: ['gewicht', 'Geschikt tot 130 kg per slaper, ook bij een tweepersoonsmaat'],
    flex6: ['instellen', '6 instellingen in 1 matras, zodat je zelf kiest hoe je ligt'],
    flex6thuis: ['instellen', '6 instellingen in 1 matras, thuis in een paar minuten om te zetten'],
    flexKoel: ['ventilatie', 'FlexGrid met ruim 1000 luchtkanalen voert warmte af'],
    flowSamen: ['personen', 'Vanaf 140 cm breed stelt ieder zijn eigen kant in: jij stevig, je partner zacht'],
    flowNaad: ['matras', 'Eén matras zonder naad in het midden, met 4 comfortniveaus'],
    flowVent: ['ventilatie', '8x betere ventilatie dankzij FlowSpring schuimveren'],
    flow4: ['omkeren', '4 comfortniveaus in 1 matras, thuis om te zetten'],
    flow4goedkoper: ['prijs', '4 comfortniveaus in 1 matras, voor minder dan de Flex'],
    essPrijs: ['prijs', 'Het voordeligste aanpasbare Kameo matras'],
    essKeer: ['omkeren', 'Keer de kern en kies zelf: medium of firm'],
    essCB: ['keurmerk', 'Beoordeeld met een 7,0 door de Consumentenbond']
  };
  var KLACHT = { rug: 'je onderrug', nek: 'je nek of schouders', heup: 'je heupen' };

  /* ── beslisregels (eerste die past wint) ── */
  function adviesMatras(a) {
    var r;
    if (a.gewicht === '110plus') r = { p: 'flex', regel: 1, red: ['flex130', 'flex6'] };
    else if (a.wie === 'samen' && (a.hardheid === 'verschil' || a.hardheid === 'weet')) r = { p: 'flow', regel: 2, red: ['flowSamen', 'flowNaad'], tweede: 'flex2x' };
    else if (a.prio === 'instellen' || a.voorkeur === 'nee') r = { p: 'flex', regel: 3, red: ['flex6thuis', 'flexKoel'] };
    else if (a.warm === 'vaak') r = a.prio === 'prijs'
      ? { p: 'flow', regel: 4, red: ['flowVent', 'flow4goedkoper'], tweede: 'flex' }
      : { p: 'flex', regel: 4, red: ['flexKoel', 'flex6'] };
    else if (a.prio === 'prijs') r = { p: 'essence', regel: 5, red: ['essPrijs', 'essKeer', 'essCB'], tweede: 'refurb' };
    else r = { p: 'flow', regel: 6, red: ['flowVent', 'flow4'] };
    r.redenen = r.red.map(function (k) { return RM[k]; });
    var k = (a.klacht || []).filter(function (x) { return x !== 'geen'; });
    if (k.length) {
      var plek = k.map(function (x) { return KLACHT[x]; }).join(' en ');
      r.redenen.push(['onderrug', 'Je wordt wel eens stijf wakker in ' + plek + ': ' + (r.p === 'essence'
        ? 'met de medium en de firm kant probeer je thuis welke hardheid je beter steunt'
        : 'je stelt thuis bij tot je goed ligt, zonder een nieuw matras te bestellen')]);
    }
    return r;
  }

  /* startinstelling: alleen regels die al op de productpagina's staan */
  function tipMatras(p, a) {
    if (p === 'essence') {
      if (a.wie === 'samen' && (a.hardheid === 'verschil' || a.hardheid === 'weet'))
        return 'Bij een tweepersoonsmaat keer je de kern voor jullie allebei. Ieder een eigen hardheid? Kies dan 2 eenpersoonsmatrassen.';
      return a.gewicht === '85-110'
        ? 'Weeg je meer dan 85 kg, begin dan op de firm kant.'
        : 'Onder de 85 kg past de medium kant meestal het best.';
    }
    if (a.houding === 'buik') return 'Als buikslaper lig je meestal fijner wat vlakker. De instelhulp op de productpagina wijst je de stevigere stand.';
    return 'Je matras komt binnen in instelling 1, de meest gekozen stand. Geef hem een week en stel daarna bij als je zachter of steviger wilt liggen.';
  }
  function waaromMatras(a) {
    return { zij: 'Je slaapt op je zij', rug: 'Je slaapt op je rug', buik: 'Je slaapt op je buik', wisselend: 'Je slaapt wisselend' }[a.houding];
  }

  /* ── toppers ──────────────────────────────────────────────────────────
     Feiten van de productpagina's pdp-d-essence-topper / -flow-topper / -flex-topper,
     aangevuld door Steinar: de Flow Topper is de soepelste (2 comforts, keerbaar),
     de Essence en de Flex liggen stugger. */
  var VRAGEN_TOPPER = [
    { id: 'doel', tegels: true, titel: 'Wat wil je veranderen aan je bed?', sub: 'Kies wat het meest speelt.', opties: [
      ['te_hard', 'Mijn bed voelt te hard', 'te-hard'],
      ['te_zacht', 'Ik zak te ver weg', 'zakken'],
      ['druk', 'Druk op schouder of heup', 'drukpunt'],
      ['warm', 'Ik slaap te warm', 'warm'],
      ['naad', 'Naad tussen twee matrassen', 'naad'],
      ['comfort', 'Gewoon meer comfort', 'comfort']] },
    { id: 'gevoel', alleenBij: function (a) { return a.doel !== 'te_hard' && a.doel !== 'te_zacht'; },
      titel: 'Hoe wil je liggen?', opties: [
      ['zachter', 'Zachter dan nu', 'zacht'],
      ['steviger', 'Steviger dan nu', 'stevig'],
      ['zelfde', 'Ongeveer zoals nu', 'balans']] },
    { id: 'staat', titel: 'Hoe is je huidige matras eraan toe?', sub: 'Een topper volgt de vorm van je matras.', opties: [
      ['goed', 'Prima, nog vlak en stevig', 'matras-goed'],
      ['oud', 'Wat ouder, maar zonder kuil', 'matras-oud'],
      ['kuil', 'Er zit een kuil of doorzakking in', 'kuil'],
      ['weet', 'Weet ik niet zeker', 'weet-niet']] },
    { id: 'basis', titel: 'Waar komt de topper op te liggen?', opties: [
      ['boxspring', 'Op een boxspring', 'boxspring'],
      ['matras', 'Op een matras met lattenbodem', 'lattenbodem'],
      ['twee', 'Op twee matrassen naast elkaar', 'naad']] },
    { id: 'houding', tegels: true, titel: 'Hoe slaap je meestal?', opties: [
      ['zij', 'Op mijn zij', 'zijslaper'],
      ['rug', 'Op mijn rug', 'rugslaper'],
      ['buik', 'Op mijn buik', 'buikslaper'],
      ['wisselend', 'Wisselend', 'wisselend']] },
    { id: 'warm', titel: 'Slaap je warm?', opties: [
      ['vaak', 'Ja, ik heb het snel warm', 'vlam'],
      ['soms', 'Soms', 'soms-warm'],
      ['nee', 'Nee, eerder koud', 'koud']] },
    { id: 'prio', titel: 'Wat vind je het belangrijkst?', opties: [
      ['prijs', 'Een voordelige prijs', 'prijs'],
      ['balans', 'Een goede balans', 'balans'],
      ['beste', 'Het beste comfort', 'beste']] }
  ];
  var NAMEN_TOPPER = { essence: 'Kameo® Essence Topper', flow: 'Kameo® Flow Topper', flex: 'Kameo® Flex Topper' };
  var R = {
    flexKoel: ['ventilatie', 'Onze koelste topper: FlexGrid voert warmte actief af'],
    flexStevig: ['matras', '8 cm premium comfort dat wat steviger ligt, zonder traagschuim'],
    flow2: ['omkeren', '2 comforts in 1: soepel of wat steviger, gewoon omkeren'],
    flowSoepel: ['zacht', 'Onze soepelste topper, met een zachte zijde van traagschuim'],
    flowZones: ['drukpunt', '5 comfortzones ontlasten schouders en heupen'],
    flowVent: ['ventilatie', '8x betere ventilatie dankzij FlowSpring schuimveren'],
    essStevig: ['stevig', 'Ligt net wat steviger, voor een klein bedrag'],
    essNaad: ['naad', 'Eén doorlopende laag: weg met de naad in het midden'],
    essVent: ['ventilatie', '6 cm FlowSpring schuimveren die 8x beter ventileren'],
    boxspring: ['boxspring', 'Op een boxspring is de topper de comfortlaag bovenop']
  };
  function adviesTopper(a) {
    if (a.staat === 'kuil') return { kuil: true, regel: 0 };
    var warm = a.warm === 'vaak' || a.doel === 'warm', r;
    if (a.doel === 'te_hard' || a.gevoel === 'zachter') r = { p: 'flow', regel: 1, red: ['flowSoepel', warm ? 'flowVent' : 'flowZones'],
      tweedeHtml: warm ? 'Heb je het echt snel warm? De <strong>Flex Topper</strong> is onze koelste topper, maar ligt steviger.' : '' };
    else if (a.doel === 'druk') r = { p: 'flow', regel: 2, red: ['flowZones', 'flowSoepel'] };
    else if (warm) r = a.prio === 'prijs'
      ? { p: 'flow', regel: 3, red: ['flowVent', 'flow2'], tweedeHtml: 'Heb je het echt snel warm? De <strong>Flex Topper</strong> is onze koelste topper.' }
      : { p: 'flex', regel: 3, red: ['flexKoel', 'flexStevig'] };
    else if (a.doel === 'naad' || a.basis === 'twee') r = { p: 'essence', regel: 4, red: ['essNaad', 'essVent'] };
    else if (a.doel === 'te_zacht' || a.gevoel === 'steviger') r = a.prio === 'beste'
      ? { p: 'flex', regel: 5, red: ['flexStevig', 'flexKoel'] }
      : { p: 'essence', regel: 5, red: ['essStevig', 'essVent'], tweedeHtml: 'Twijfel je nog? De <strong>Flow Topper</strong> heeft een soepele én een stevigere kant.' };
    else if (a.houding === 'zij') r = { p: 'flow', regel: 6, red: ['flowZones', 'flow2'] };
    else r = a.prio === 'prijs' ? { p: 'essence', regel: 7, red: ['essStevig', 'essVent'] }
      : a.prio === 'beste' ? { p: 'flex', regel: 7, red: ['flexStevig', 'flexKoel'] }
      : { p: 'flow', regel: 7, red: ['flow2', 'flowVent'] };
    if (a.basis === 'boxspring') r.red = r.red.concat(['boxspring']);
    r.redenen = r.red.map(function (k) { return R[k]; });
    if (a.staat === 'weet') r.let = 'Twijfel je over je matras? Druk met je hand op het midden en op de rand. Voelt het midden duidelijk lager, dan helpt een topper maar beperkt.';
    return r;
  }
  function tipTopper(p, a) {
    if (p === 'flow') return a.doel === 'te_zacht' || a.gevoel === 'steviger'
      ? 'Leg de stevigere kant boven. Liever soepeler? Rits de hoes open en draai de kern om.'
      : 'Begin met de soepele kant boven. Liever wat steviger? Rits de hoes open en draai de kern om.';
    return 'Leg de topper op je huidige matras. De antislip onderzijde houdt hem netjes op zijn plek.';
  }
  function waaromTopper(a) {
    return { te_hard: 'Je bed voelt te hard', te_zacht: 'Je zakt te ver weg', druk: 'Je voelt druk op schouder of heup',
      warm: 'Je slaapt te warm', naad: 'Je hebt last van de naad', comfort: 'Je wilt meer comfort' }[a.doel];
  }

  /* ── config (dealteksten uit de productmetafields, alleen als de actie aan staat) ── */
  var CONFIG = {};
  try { CONFIG = JSON.parse((document.getElementById('kkh-config') || {}).textContent || '{}'); } catch (e) {}
  var TYPE = CONFIG.type === 'topper' ? 'topper' : 'matras';
  var VRAGEN = TYPE === 'topper' ? VRAGEN_TOPPER : VRAGEN_MATRAS;
  var NAMEN = TYPE === 'topper' ? NAMEN_TOPPER : NAMEN_MATRAS;
  var advies = TYPE === 'topper' ? adviesTopper : adviesMatras;
  var tip = TYPE === 'topper' ? tipTopper : tipMatras;
  var waarom = TYPE === 'topper' ? waaromTopper : waaromMatras;
  var BRON = TYPE === 'topper' ? 'keuzehulp-topper' : 'keuzehulp';
  var OPSLAG = TYPE === 'topper' ? 'kkh_advies_topper' : 'kkh_advies';

  /* ── kaarten op de pagina ────────────────────────────────────────────── */
  function sleutel(tekst) {
    tekst = (tekst || '').toLowerCase();
    if (tekst.indexOf('essence') > -1) return 'essence';
    if (tekst.indexOf('flow') > -1) return 'flow';
    if (tekst.indexOf('flex') > -1) return 'flex';
    return null;
  }
  function kaarten() {
    var uit = {};
    document.querySelectorAll('.product-card-modern.pcm2').forEach(function (k) {
      var s = sleutel((k.querySelector('.product-card-modern__title') || {}).textContent);
      if (s && !uit[s]) uit[s] = k;
    });
    return uit;
  }
  function kaartUrl(k) {
    var a = k && k.querySelector('.product-card-modern__button');
    var h = a && a.getAttribute('href');
    return h && h !== '#' ? h : null;
  }
  function kaartPrijs(k) {
    var p = k && k.querySelector('.product-card-modern__price .price');
    if (!p) return null;
    var t = p.textContent.trim();
    if (!t) return null;
    var v = k.querySelector('.product-card-modern__price .compare-at-price');
    var pre = (k.querySelector('.product-card-modern__price_prefix') || {}).textContent || '';
    var geld = function (x) { x = x.trim(); return /€/.test(x) ? x : '€ ' + x; };
    return { prijs: geld(t), vergelijk: v && v.textContent.trim() ? geld(v.textContent) : null, va: /v\.a\./i.test(pre) };
  }
  /* één rood actielabel, dat bij de vanafprijs hoort: de 1+1 uit het metafield
     (alleen als die actie aan staat, want de vanafprijs is een eenpersoonsmaat),
     anders het kortingslabel van de kaart */
  function deals(p, k) {
    var d = (CONFIG.deals || {})[p];
    if (d) return [d];
    var lab = k && k.querySelector('.pcm2__discount');
    return lab && lab.textContent.trim() ? [lab.textContent.trim()] : [];
  }

  /* ── meten ───────────────────────────────────────────────────────────── */
  function magMeten() {
    try {
      if (window.Cookiebot && window.Cookiebot.consent) return !!window.Cookiebot.consent.statistics;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.analyticsProcessingAllowed) return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return false;
  }
  function sessie() {
    var m = document.cookie.match('(?:^|; )kmc_sid=([^;]*)');
    if (m) return decodeURIComponent(m[1]);
    var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    document.cookie = 'kmc_sid=' + id + ';path=/;max-age=2592000;SameSite=Lax';
    return id;
  }
  /* GA4-bezoeker en -sessie uit de cookies van de Google-pixel, zodat de app de events in GA4
     aan dezelfde bezoeker en sessie kan hangen (de app-proxy geeft geen cookies door) */
  function gaIds() {
    try {
      var c = document.cookie;
      var ga = c.match(/(?:^|; )_ga=GA\d\.\d\.(\d+\.\d+)/);
      var s = c.match(/(?:^|; )_ga_C61PWSSNT6=GS\d\.\d\.s?(\d+)/);
      return ga ? { cid: ga[1], sid: s ? s[1] : null } : null;
    } catch (e) { return null; }
  }
  function meet(event, code, slot) {
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'kameo_keuzehulp', kh_actie: event, kh_code: code || null, kh_slot: slot || null });
    } catch (e) {}
    if (/kab_force|kkh_test/.test(location.search)) return; // eigen QA niet meetellen
    try {
      if (!magMeten()) return;
      var b = Math.min(innerWidth, innerHeight);
      var lading = JSON.stringify({
        sessie: sessie(),
        apparaat: b < 768 ? 'mobile' : b < 1024 ? 'tablet' : 'desktop',
        events: [{ event: event, ts: Date.now(), bron: BRON, code: code || null, slot: slot || null }],
        ga: gaIds()
      });
      var pad = '/apps/kameo-cart/e';
      if (!(navigator.sendBeacon && navigator.sendBeacon(pad, new Blob([lading], { type: 'application/json' })))) {
        fetch(pad, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: lading, keepalive: true }).catch(function () {});
      }
    } catch (e) { /* meten mag de keuzehulp nooit breken */ }
  }

  /* ── modal ───────────────────────────────────────────────────────────── */
  var el, band, paneel, stap = 0, antwoorden = {}, laatsteFocus = null, uitkomst = null;

  function zichtbareVragen() {
    return VRAGEN.filter(function (v) { return !v.alleenBij || v.alleenBij(antwoorden); });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function labelVan(v, w) {
    var o = v.opties.filter(function (x) { return x[0] === w; })[0];
    return o ? o[1] : w;
  }

  function bouw() {
    el = document.createElement('div');
    el.className = 'kkh';
    el.hidden = true;
    el.innerHTML =
      '<div class="kkh__achter" data-kkh-sluit></div>' +
      '<div class="kkh__vel" role="dialog" aria-modal="true" aria-labelledby="kkh-kop">' +
        '<div class="kkh__top">' +
          '<div class="kkh__balk">' +
            '<button type="button" class="kkh__rond kkh__terug" aria-label="Vorige vraag"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button>' +
            '<div class="kkh__voortgang" aria-hidden="true"><span></span></div>' +
            '<button type="button" class="kkh__rond kkh__sluit" data-kkh-sluit aria-label="Sluiten"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
          '</div>' +
          '<div class="kkh__band"></div>' +
        '</div>' +
        '<div class="kkh__paneel" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(el);
    band = el.querySelector('.kkh__band');
    paneel = el.querySelector('.kkh__paneel');
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-kkh-sluit]')) { e.preventDefault(); sluit('knop'); }
    });
    el.querySelector('.kkh__terug').addEventListener('click', function () {
      if (uitkomst) {
        var lijst = zichtbareVragen();
        stap = uitkomst.kuil ? lijst.map(function (v) { return v.id; }).indexOf('staat') : lijst.length - 1;
        uitkomst = null;
      } else if (stap > 0) stap--;
      toonVraag(-1);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { sluit('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = el.querySelectorAll('button:not([hidden]):not([disabled]), a[href]');
      f = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  function voortgang(fractie) {
    el.querySelector('.kkh__voortgang span').style.transform = 'scaleX(' + Math.max(0.04, fractie) + ')';
  }

  function wissel(bandHtml, html, richting, klasse) {
    [band, paneel].forEach(function (x) { x.classList.remove('kkh--in', 'kkh--terug'); });
    void paneel.offsetWidth;
    band.innerHTML = bandHtml;
    paneel.innerHTML = html;
    el.querySelector('.kkh__vel').classList.toggle('kkh__vel--advies', klasse === 'advies');
    [band, paneel].forEach(function (x) { x.classList.add(richting < 0 ? 'kkh--terug' : 'kkh--in'); });
    paneel.scrollTop = 0;
  }

  function toonVraag(richting) {
    var lijst = zichtbareVragen();
    var v = lijst[stap];
    var titel = typeof v.titel === 'function' ? v.titel(antwoorden) : v.titel;
    var gekozen = antwoorden[v.id], reeks = Array.isArray(gekozen) ? gekozen : [];
    el.querySelector('.kkh__terug').hidden = stap === 0;
    voortgang((stap + 1) / (lijst.length + 1));
    var b = '<p class="kkh__stap">Vraag ' + (stap + 1) + ' van ' + lijst.length + '</p>' +
      '<h2 class="kkh__kop" id="kkh-kop">' + esc(titel) + '</h2>' +
      (v.sub ? '<p class="kkh__sub">' + esc(v.sub) + '</p>' : '');
    var h = '<div class="kkh__opties' + (v.tegels ? ' kkh__opties--tegels' : '') + '" role="' + (v.meer ? 'group' : 'radiogroup') + '" aria-labelledby="kkh-kop">';
    v.opties.forEach(function (o) {
      var aan = v.meer ? reeks.indexOf(o[0]) > -1 : gekozen === o[0];
      h += '<button type="button" role="' + (v.meer ? 'checkbox' : 'radio') + '" aria-checked="' + aan + '" class="kkh__optie' + (o[2] ? ' kkh__optie--ic' : '') + (aan ? ' is-gekozen' : '') + '" data-waarde="' + o[0] + '">' +
        (o[2] ? '<span class="kkh__ic" aria-hidden="true">' + icoon(o[2]) + '</span>' : '') +
        '<span class="kkh__label">' + esc(o[1]) + '</span>' +
        (v.meer ? '<span class="kkh__vink" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>' : '<span class="kkh__bol" aria-hidden="true"></span>') +
        '</button>';
    });
    h += '</div>';
    if (v.meer) h += '<button type="button" class="button kkh__verder" data-kkh-verder' + (reeks.length ? '' : ' disabled') + '>Verder</button>';
    wissel(b, h, richting);
    paneel.querySelectorAll('.kkh__optie').forEach(function (knop) {
      knop.addEventListener('click', function () { kies(v, knop); });
    });
    var verder = paneel.querySelector('[data-kkh-verder]');
    if (verder) verder.addEventListener('click', function () {
      meet('kh_antwoord', v.id + ':' + (antwoorden[v.id] || []).join('+'), stap + 1);
      volgende();
    });
    var eerst = paneel.querySelector('.is-gekozen') || paneel.querySelector('.kkh__optie');
    if (eerst) eerst.focus({ preventScroll: true });
  }

  var bezig = false;
  function kies(v, knop) {
    var w = knop.getAttribute('data-waarde');
    if (v.meer) {
      var a = (antwoorden[v.id] || []).slice();
      if (w === 'geen') a = a.indexOf('geen') > -1 ? [] : ['geen'];
      else {
        a = a.filter(function (x) { return x !== 'geen'; });
        var i = a.indexOf(w);
        if (i > -1) a.splice(i, 1); else a.push(w);
      }
      antwoorden[v.id] = a;
      paneel.querySelectorAll('.kkh__optie').forEach(function (b) {
        var aan = a.indexOf(b.getAttribute('data-waarde')) > -1;
        b.classList.toggle('is-gekozen', aan);
        b.setAttribute('aria-checked', aan);
      });
      paneel.querySelector('[data-kkh-verder]').disabled = !a.length;
      return;
    }
    if (bezig) return;
    bezig = true;
    antwoorden[v.id] = w;
    if (v.id === 'wie' && w !== 'samen') delete antwoorden.hardheid;
    if (v.id === 'doel' && (w === 'te_hard' || w === 'te_zacht')) delete antwoorden.gevoel;
    paneel.querySelectorAll('.kkh__optie').forEach(function (b) {
      var aan = b === knop;
      b.classList.toggle('is-gekozen', aan);
      b.setAttribute('aria-checked', aan);
    });
    meet('kh_antwoord', v.id + ':' + w, stap + 1);
    setTimeout(function () { bezig = false; volgende(); }, 240);
  }

  function volgende() {
    // een kuil in het matras: een topper helpt niet, dus direct het eerlijke advies
    if (TYPE === 'topper' && antwoorden.staat === 'kuil') { toonAdvies(); return; }
    var lijst = zichtbareVragen();
    if (stap < lijst.length - 1) { stap++; toonVraag(1); }
    else toonAdvies();
  }

  function antwoordChips() {
    var h = '';
    zichtbareVragen().forEach(function (v, i) {
      var w = antwoorden[v.id];
      if (w === undefined) return;
      var t = Array.isArray(w) ? w.map(function (x) { return labelVan(v, x); }).join(', ') : labelVan(v, w);
      h += '<button type="button" data-kkh-ga="' + i + '" aria-label="Wijzig: ' + esc(t) + '">' + esc(t) + ' <span aria-hidden="true">&#9998;</span></button>';
    });
    return h ? '<div class="kkh__chips" aria-label="Jouw antwoorden">' + h + '</div>' : '';
  }

  function toonAdvies() {
    uitkomst = advies(antwoorden);
    voortgang(1);
    el.querySelector('.kkh__terug').hidden = false;
    var b, h;

    if (uitkomst.kuil) {
      meet('kh_advies', 'kuil', 0);
      b = '<span class="kkh__match kkh__match--let">Eerlijk advies</span>' +
        '<h2 class="kkh__kop kkh__kop--product" id="kkh-kop">Een topper lost een kuil niet op</h2>';
      h = '<p class="kkh__uitleg">Een topper volgt de vorm van je matras. Zit er een kuil in, dan lig je daar met topper en al in. Dan slaap je beter op een nieuw matras.</p>' +
        '<ul class="kkh__redenen">' +
          '<li><span class="kkh__ri" aria-hidden="true">' + icoon('instellen') + '</span><span>Alle drie de Kameo matrassen stel je thuis zelf in: Essence, Flow en Flex</span></li>' +
          '<li><span class="kkh__ri" aria-hidden="true">' + icoon('prijs') + '</span><span>Liever voordeliger? 7 refurbished matrassen, fors voordeliger dan nieuw</span></li>' +
        '</ul>' +
        '<div class="kkh__knoppen">' +
          '<a class="button kkh__knop" href="/collections/matrassen#keuzehulp" data-kkh-kuil="matras">Help mij een matras kiezen</a>' +
          '<a class="button button-secondary kkh__knop" href="/collections/refurbished" data-kkh-kuil="refurbished">Bekijk refurbished</a>' +
        '</div>' +
        '<p class="kkh__tweede">Twijfel je of het echt een kuil is? <button type="button" class="kkh__linkknop" data-kkh-twijfel>Kies dan &lsquo;Weet ik niet zeker&rsquo;</button> en we adviseren toch een topper.</p>' +
        antwoordChips() +
        '<p class="kkh__opnieuw"><button type="button" data-kkh-opnieuw>Opnieuw beginnen</button></p>';
      wissel(b, h, 1, 'advies');
      paneel.querySelectorAll('[data-kkh-kuil]').forEach(function (a) {
        a.addEventListener('click', function () { meet('kh_klik', 'kuil:' + a.getAttribute('data-kkh-kuil'), 0); });
      });
      paneel.querySelector('[data-kkh-twijfel]').addEventListener('click', function () {
        antwoorden.staat = 'weet'; uitkomst = null;
        stap = zichtbareVragen().map(function (v) { return v.id; }).indexOf('staat');
        toonVraag(-1);
      });
      naAdvies();
      (paneel.querySelector('a, button')).focus({ preventScroll: true });
      return;
    }

    var k = kaarten();
    var p = uitkomst.p, kaart = k[p], url = kaartUrl(kaart), prijs = kaartPrijs(kaart), acties = deals(p, kaart);
    // op een productpagina staan geen kaarten: naam, link en prijs komen dan uit de config van kkh-pdp-kaart
    var pd = (CONFIG.producten || {})[p], hier = !kaart && CONFIG.huidig === p;
    if (!kaart && pd) {
      var euro = function (x) { return x && !/€/.test(x) ? '€ ' + x : x; };
      url = pd.url; prijs = pd.prijs ? { prijs: euro(pd.prijs), vergelijk: euro(pd.vergelijk) || null, va: true } : null;
    }
    meet('kh_advies', p, uitkomst.regel);
    try { sessionStorage.setItem(OPSLAG, p); } catch (e) {}

    b = '<span class="kkh__match">Beste keuze voor jou</span>' +
      '<h2 class="kkh__kop kkh__kop--product" id="kkh-kop">' + esc(NAMEN[p]) + '</h2>';

    h = '';
    if (acties.length || prijs) {
      h += '<div class="kkh__prijsrij">' +
        (acties.length ? '<div class="kkh__acties-labels">' + acties.map(function (a) { return '<span class="kkh__deal">' + esc(a) + '</span>'; }).join('') + '</div>' : '') +
        (prijs ? '<p class="kkh__prijs">' + (prijs.va ? '<span class="kkh__va">vanaf</span>' : '') +
          '<strong>' + esc(prijs.prijs) + '</strong>' +
          (prijs.vergelijk ? '<s>' + esc(prijs.vergelijk) + '</s>' : '') + '</p>' : '') +
        '</div>';
    }
    var kop = waarom(antwoorden);
    h += '<p class="kkh__waarom">' + (kop ? esc(kop) + '. ' : '') + 'Daarom past deze ' + (TYPE === 'topper' ? 'topper' : 'matras') + ' bij je:</p>';
    h += '<ul class="kkh__redenen">';
    uitkomst.redenen.forEach(function (r) {
      h += '<li><span class="kkh__ri" aria-hidden="true">' + icoon(r[0]) + '</span><span>' + esc(r[1]) + '</span></li>';
    });
    h += '</ul>';
    if (uitkomst.let) h += '<p class="kkh__tip kkh__tip--let">' + esc(uitkomst.let) + '</p>';
    h += '<p class="kkh__tip">' + esc(tip(p, antwoorden)) + '</p>';

    if (uitkomst.tweede === 'flex2x') {
      var d2 = (CONFIG.deals || {}).flex;
      h += '<p class="kkh__tweede">Liever ieder een volledig eigen matras? Kies 2 eenpersoons <strong>Flex</strong> matrassen, met elk 6 instellingen' + (d2 ? ' (' + esc(d2) + ')' : '') + '.</p>';
    } else if (uitkomst.tweede === 'flex') {
      h += '<p class="kkh__tweede">Heb je het echt snel warm? Het <strong>Flex</strong> matras verkoelt actief met FlexGrid.</p>';
    } else if (uitkomst.tweede === 'refurb') {
      h += '<p class="kkh__tweede">Liever nog voordeliger? Er zijn <a href="/collections/refurbished" data-kkh-refurb><strong>7 refurbished matrassen</strong></a>, fors voordeliger dan nieuw.</p>';
    } else if (uitkomst.tweedeHtml) {
      h += '<p class="kkh__tweede">' + uitkomst.tweedeHtml + '</p>';
    }

    h += '<div class="kkh__knoppen">' +
      (hier ? '<button type="button" class="button kkh__knop" data-kkh-kies>Kies je maat</button>'
        : (kaart ? '<button type="button" class="button kkh__knop" data-kkh-toon>Toon op de pagina</button>' : '') +
          (url ? '<a class="button ' + (kaart ? 'button-secondary ' : '') + 'kkh__knop" href="' + esc(url) + '" data-kkh-bekijk>Bekijk ' + (pd && !kaart ? esc(pd.naam) : (TYPE === 'topper' ? 'topper' : 'matras')) + '</a>' : '')) +
      '</div>' +
      '<p class="kkh__chat"><a href="#kameo-chat" data-kkh-chat>Nog vragen? Chat met een slaapexpert</a></p>' +
      antwoordChips() +
      '<p class="kkh__opnieuw"><button type="button" data-kkh-opnieuw>Opnieuw beginnen</button></p>';
    wissel(b, h, 1, 'advies');

    var toon = paneel.querySelector('[data-kkh-toon]');
    if (toon) toon.addEventListener('click', function () { meet('kh_klik', 'toon', uitkomst.regel); sluit('advies'); markeer(p, true); });
    var kies = paneel.querySelector('[data-kkh-kies]');
    if (kies) kies.addEventListener('click', function () {
      // advies = het product dat de bezoeker al bekijkt: terug naar de maatkeuze
      meet('kh_klik', 'kies:' + p, uitkomst.regel);
      sluit('advies');
      var doel = document.querySelector('.kd-kaart') || document.querySelector('#maatBlok');
      if (doel) {
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        doel.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        var knop = doel.querySelector('.kd__knop, button');
        if (knop) setTimeout(function () { knop.focus({ preventScroll: true }); }, 400);
      }
    });
    var bekijk = paneel.querySelector('[data-kkh-bekijk]');
    if (bekijk) bekijk.addEventListener('click', function () { meet('kh_klik', 'bekijk:' + p, uitkomst.regel); });
    var refurb = paneel.querySelector('[data-kkh-refurb]');
    if (refurb) refurb.addEventListener('click', function () { meet('kh_klik', 'refurbished', uitkomst.regel); });
    paneel.querySelector('[data-kkh-chat]').addEventListener('click', function (e) {
      e.preventDefault();
      meet('kh_klik', 'chat', uitkomst.regel);
      sluit('chat');
      // de chatwidget luistert naar klikken op links met href="#kameo-chat"
      var a = document.createElement('a');
      a.href = '#kameo-chat'; a.style.display = 'none';
      document.body.appendChild(a); a.click(); a.remove();
    });
    naAdvies();
    (kies || toon || bekijk || paneel.querySelector('a, button')).focus({ preventScroll: true });
  }

  /* gedeeld door beide adviesschermen: antwoord wijzigen en opnieuw beginnen */
  function naAdvies() {
    paneel.querySelectorAll('[data-kkh-ga]').forEach(function (x) {
      x.addEventListener('click', function () {
        meet('kh_klik', 'wijzig', uitkomst && uitkomst.regel);
        uitkomst = null; stap = +x.getAttribute('data-kkh-ga'); toonVraag(-1);
      });
    });
    paneel.querySelector('[data-kkh-opnieuw]').addEventListener('click', function () {
      antwoorden = {}; uitkomst = null; stap = 0; toonVraag(-1);
    });
  }

  /* ── kaart oplichten ─────────────────────────────────────────────────── */
  function markeer(p, scroll, tekst, klasse) {
    klasse = klasse || 'kkh-match';
    var k = kaarten();
    Object.keys(k).forEach(function (s) {
      k[s].classList.remove('kkh-match');
      k[s].classList.remove('kmn-gekozen');
      var oud = k[s].querySelector('.kkh-badge');
      if (oud) oud.remove();
    });
    var kaart = k[p];
    if (!kaart) return;
    kaart.classList.add(klasse);
    document.documentElement.classList.add('kkh-heeft-advies');
    var badge = document.createElement('span');
    badge.className = klasse === 'kmn-gekozen' ? 'kkh-badge kmn-badge' : 'kkh-badge';
    badge.textContent = tekst || 'Beste keuze voor jou';
    kaart.insertBefore(badge, kaart.firstChild);
    if (!scroll) return;
    var slide = kaart.closest('.swiper-slide');
    var houder = kaart.closest('.swiper-initialized') || kaart.closest('.collection-modern');
    if (slide && houder && houder.swiper) {
      var i = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      try { houder.swiper.slideTo(i, 500); } catch (e) {}
    }
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    // de kaart is vaak hoger dan het scherm: scrol naar de bovenkant, onder de vaste header
    var kop = document.querySelector('.header-section');
    var kopHoogte = kop && /sticky|fixed/.test(getComputedStyle(kop).position) ? kop.offsetHeight : 0;
    var doel = kaart.getBoundingClientRect().top + scrollY - kopHoogte - 24;
    window.scrollTo({ top: Math.max(0, doel), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ── openen / sluiten ────────────────────────────────────────────────── */
  /* start = 'vraag:waarde' van een tegel in het startblok (die vraag is dan al beantwoord);
     bron = waar de bezoeker vandaan kwam (blok, tegel, pdp, menu) */
  function open(e, start, bron) {
    if (e) e.preventDefault();
    if (!el) bouw();
    laatsteFocus = document.activeElement;
    antwoorden = {}; uitkomst = null; stap = 0;
    var vooraf = start && start.split(':');
    if (vooraf && vooraf[1] && VRAGEN.some(function (v) { return v.id === vooraf[0]; })) antwoorden[vooraf[0]] = vooraf[1];
    var lijst = zichtbareVragen();
    for (var i = 0; i < lijst.length; i++) { if (antwoorden[lijst[i].id] === undefined) { stap = i; break; } }
    el.hidden = false;
    document.documentElement.classList.add('kkh-open');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    toonVraag(1);
    meet('kh_open', bron || null, null);
    if (vooraf && antwoorden[vooraf[0]]) meet('kh_antwoord', vooraf[0] + ':' + vooraf[1], 0);
  }
  function sluit(reden) {
    if (!el || el.hidden) return;
    // afhaken: welke vraag stond open (de naam, want het nummer verschuift door voorwaardelijke vragen)
    if (!uitkomst) meet('kh_sluit', ((zichtbareVragen()[stap] || {}).id || '?') + ':' + (reden || ''), stap + 1);
    el.classList.remove('is-open');
    document.documentElement.classList.remove('kkh-open');
    setTimeout(function () { el.hidden = true; }, 220);
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kkh-open]');
    if (t) open(e, t.getAttribute('data-kkh-antwoord'), t.getAttribute('data-kkh-bron') || 'knop');
  });

  /* terug van een productpagina: het eerdere advies blijft zichtbaar */
  function herstel() {
    try { var p = sessionStorage.getItem(OPSLAG); if (p) markeer(p, false); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', herstel);
  else herstel();

  /* vanuit het hoofdmenu (B+, 2026-10-10): #kies-<lijn> licht dat model uit, #keuzehulp opent de hulp */
  function vanuitMenu() {
    var h = (location.hash || '').toLowerCase();
    if (h === '#keuzehulp') { open(null, null, 'link'); return; }
    // vanaf de productpagina, eventueel met een vooraf gekozen antwoord: #keuzehulp-pdp=vraag:waarde
    var pdp = h.match(/^#keuzehulp-pdp(?:=([a-z]+:[a-z0-9_]+))?$/);
    if (pdp) { open(null, pdp[1] || null, 'pdp'); return; }
    var m = h.match(/^#kies-(essence|flow|flex)$/);
    if (m && kaarten()[m[1]]) markeer(m[1], true, 'Je bekeek dit model', 'kmn-gekozen');
  }
  function naHash() {
    var la = document.querySelector('header-drawer');
    if (la && typeof la.close === 'function') { try { la.close(); } catch (e) {} }
    vanuitMenu();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(vanuitMenu, 250); });
  else setTimeout(vanuitMenu, 250);
  window.addEventListener('hashchange', naHash);
})();
